<template>
  <Icon>
    <template #component>
      <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
        <path
          d="M512 128a384 384 0 0 0-384 384 384 384 0 0 0 384 384 384 384 0 0 0 384-384c0-21.333333-1.706667-42.666667-5.546667-64C878.933333 426.666667 853.333333 426.666667 853.333333 426.666667h-85.333333V384c0-42.666667-42.666667-42.666667-42.666667-42.666667h-85.333333V298.666667c0-42.666667-42.666667-42.666667-42.666667-42.666667h-42.666666V170.666667c0-42.666667-42.666667-42.666667-42.666667-42.666667M405.333333 256A64 64 0 0 1 469.333333 320 64 64 0 0 1 405.333333 384 64 64 0 0 1 341.333333 320 64 64 0 0 1 405.333333 256m-128 170.666667A64 64 0 0 1 341.333333 490.666667 64 64 0 0 1 277.333333 554.666667 64 64 0 0 1 213.333333 490.666667 64 64 0 0 1 277.333333 426.666667m213.333334 42.666666a64 64 0 0 1 64 64 64 64 0 0 1-64 64 64 64 0 0 1-64-64 64 64 0 0 1 64-64m213.333333 85.333334a64 64 0 0 1 64 64 64 64 0 0 1-64 64 64 64 0 0 1-64-64 64 64 0 0 1 64-64M469.333333 682.666667a64 64 0 0 1 64 64A64 64 0 0 1 469.333333 810.666667a64 64 0 0 1-64-64A64 64 0 0 1 469.333333 682.666667z"
          fill=""
          p-id="1075"
        ></path>
      </svg>
    </template>
  </Icon>
</template>
<script lang="ts">
interface size {
  height: number;
  width: number;
}
import { defineComponent } from "vue";
import Icon from "@ant-design/icons-vue";
export default defineComponent({
  components: {
    Icon,
  },
});
</script>
<style scoped>
.custom-icons-list :deep(.anticon) {
  margin-right: 6px;
}
</style>
